import { Button } from '@ksyos/design-system';
import { useState } from 'react';
import type { LabelType } from '@common/customControls/getServiceLabel';
import type { ProcessEntity, ServiceCode, ServiceType } from '@common/enums';
import { ToastType } from '@common/enums';
import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { translateKey } from '../../../translate';
import { showServiceToast } from '../../../utils/showToast';
import { SureToCancelModal } from '../SureToCancelModal';

interface ICancelButtonProps {
    buttonText?: string;
    cancel: () => Promise<void>;
    diagnosticReport?: IDiagnosticReportGetOne;
    entity: ProcessEntity;
    isExisting?: boolean;
    isInReadMode?: boolean;
    request?: IRequestGetOne;
    revertChanges?: () => Promise<void>;
    serviceCode: ServiceCode;
    serviceType: ServiceType;
    tabIndex?: number;
    toastServiceLabelType?: LabelType;
}

export function CancelButton(props: ICancelButtonProps) {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                className="automation-cancel"
                onClick={() => setShowModal(true)}
                tabIndex={props.tabIndex}
                type="button"
                variant="outline"
            >
                {props.buttonText || translateKey('common.cancel')}
            </Button>

            {showModal && (
                <SureToCancelModal
                    entity={props.entity}
                    isExisting={props.isExisting || false}
                    isInReadMode={props.isInReadMode || false}
                    onNo={async () => setShowModal(false)}
                    onYes={async () => await onYesCancel()}
                    serviceType={props.serviceType}
                />
            )}
        </>
    );

    async function onYesCancel() {
        setShowModal(false);
        const toastTranslateKey = props.isExisting ? 'toast.cancelExistingSuccess' : 'toast.cancelSuccess';
        const labelType = props.toastServiceLabelType || props.entity;
        showServiceToast(
            ToastType.info,
            toastTranslateKey,
            props.serviceCode,
            labelType,
            translateKey('toast.cancelDefaultMessage')
        );
        await props.revertChanges?.();
        await props.cancel();
    }
}
